export default "__VITE_ASSET__CVRQbE26__"